import React from "react";
import {
  Modal,
  Box,
  Typography,
  TextField,
  Grid,
  FormControl,
  Select,
  MenuItem,
  Chip,
  Stack,
  Button,
} from "@mui/material";

const TransferStockModal = ({ open, onClose, data, handlers }) => {
  const {
    actionType,
    actionQuantities,
    currentTransferMaterial,
    selectedCity,
    cities,
    selectedLocation,
    cityStorageLocations,
  } = data;

  const {
    onQuantityChange,
    onCityChange,
    onLocationChange,
    onConfirm,
  } = handlers;

  const rawMaterialId = currentTransferMaterial?.rawMaterial?._id;
  const quantity = rawMaterialId ? actionQuantities?.[rawMaterialId] || "" : "";

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          width: { xs: "92%", sm: 720 },
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          background: "linear-gradient(135deg, #f7f9fc, #ffffff)",
          boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.2)",
          p: 4,
          borderRadius: 3,
        }}
      >
        <Typography
          variant="h5"
          sx={{
            mb: 1,
            textAlign: "center",
            fontWeight: 900,
            color: "#003049",
          }}
        >
          Select Storage Location
        </Typography>

        <Typography
          variant="body2"
          sx={{
            mb: 3,
            textAlign: "center",
            fontWeight: 600,
            color: "#334155",
          }}
        >
          {actionType === "debit"
            ? "The entered quantity will be transferred to the selected storage location from the outlet."
            : "The entered quantity will be debited from the selected storage location and transferred to the outlet."}
        </Typography>

        <Box sx={{ mb: 3 }}>
          <Typography
            sx={{
              fontSize: 12,
              fontWeight: 800,
              color: "#334155",
              mb: 0.8,
            }}
          >
            Quantity
          </Typography>

          <TextField
            fullWidth
            type="number"
            inputProps={{ min: 0, step: "0.01" }}
            variant="outlined"
            value={quantity}
            onChange={(e) => onQuantityChange(rawMaterialId, e.target.value)}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: 2,
                height: 52,
                background: "#fff",
              },
            }}
          />
        </Box>

        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Typography
              sx={{
                fontSize: 12,
                fontWeight: 800,
                color: "#334155",
                mb: 0.8,
              }}
            >
              City
            </Typography>

            <FormControl fullWidth>
              <Select
                value={selectedCity}
                onChange={onCityChange}
                displayEmpty
                sx={{ bgcolor: "#fff", borderRadius: 2, height: 52 }}
              >
                <MenuItem value="">
                  <em>Select a city</em>
                </MenuItem>

                {cities?.map((city) => (
                  <MenuItem key={city} value={city}>
                    {city}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Typography
              sx={{
                fontSize: 12,
                fontWeight: 800,
                color: "#334155",
                mb: 0.8,
              }}
            >
              Location
            </Typography>

            <FormControl fullWidth>
              <Select
                value={selectedLocation}
                onChange={(e) => onLocationChange(e.target.value)}
                displayEmpty
                disabled={!selectedCity}
                sx={{ bgcolor: "#fff", borderRadius: 2, height: 52 }}
              >
                <MenuItem value="">
                  <em>Select a location</em>
                </MenuItem>

                {cityStorageLocations?.map((location) => (
                  <MenuItem
                    key={location?._id}
                    value={location?._id}
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <span>{location?.name}</span>

                    {location?.stockInfo?.[0]?.currentStock !== undefined && (
                      <Chip
                        size="small"
                        label={`Stock: ${location.stockInfo[0].currentStock}`}
                        sx={{
                          ml: 1,
                          fontWeight: 900,
                          borderRadius: 2,
                          background: "#d1e7dd",
                          color: "#155724",
                        }}
                        variant="outlined"
                      />
                    )}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>

        <Stack direction="row" spacing={2} sx={{ mt: 3 }}>
          <Button
            variant="outlined"
            onClick={onClose}
            sx={{
              flex: 1,
              height: 50,
              borderRadius: 2,
              fontWeight: 900,
              borderColor: "#d32f2f",
              color: "#d32f2f",
              "&:hover": {
                backgroundColor: "#fdecea",
                borderColor: "#c62828",
              },
            }}
          >
            Cancel
          </Button>

          <Button
            variant="contained"
            onClick={onConfirm}
            disabled={!selectedLocation}
            sx={{
              flex: 1,
              height: 50,
              borderRadius: 2,
              fontWeight: 900,
              backgroundColor: "#003049",
              "&:hover": { backgroundColor: "#002437" },
              "&.Mui-disabled": {
                backgroundColor: "#b0bec5",
                color: "#ffffff",
              },
            }}
          >
            Confirm
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
};

export default TransferStockModal;